export default __webpack_public_path__ + "static/media/Dylan-Best-Resume.4625cfd1.pdf";